<div class="row">
  <div class="col-9">
    <div [ngSwitch]="question.answerType">
      <div *ngSwitchCase="questionType.Text">
        <app-text-form [question]="question" [questionType]="questionType.Text" [categoryIds]="question.categoryIds">
        </app-text-form>
      </div>
      <div *ngSwitchCase="questionType.Number">
        <app-text-form [question]="question" [questionType]="questionType.Number" [categoryIds]="question.categoryIds">
        </app-text-form>
      </div>
      <div *ngSwitchCase="questionType.Checkbox">
        <app-checkbox-radio-form
          [question]="question"
          [questionType]="questionType.Checkbox"
          [categoryIds]="question.categoryIds"
        >
        </app-checkbox-radio-form>
      </div>
      <div *ngSwitchCase="questionType.SatisfactionRate">
        <app-checkbox-radio-form
          [question]="question"
          [questionType]="questionType.SatisfactionRate"
          [categoryIds]="question.categoryIds"
        >
        </app-checkbox-radio-form>
      </div>
      <div *ngSwitchCase="questionType.Radiobutton">
        <app-checkbox-radio-form
          [question]="question"
          [questionType]="questionType.Radiobutton"
          [categoryIds]="question.categoryIds"
        >
        </app-checkbox-radio-form>
      </div>
      <div *ngSwitchCase="questionType.MatrixRadiobutton">
        <app-matrix-form [question]="question" [questionType]="questionType.MatrixRadiobutton"></app-matrix-form>
      </div>
      <div *ngSwitchCase="questionType.MatrixCheckbox">
        <app-matrix-form [question]="question" [questionType]="questionType.MatrixCheckbox"></app-matrix-form>
      </div>
      <div *ngSwitchCase="questionType.Rating">
        <app-checkbox-radio-form
          [question]="question"
          [questionType]="questionType.Rating"
          [categoryIds]="question.categoryIds"
        >
        </app-checkbox-radio-form>
      </div>
      <div *ngSwitchDefault>
        <app-text-form [question]="question" [questionType]="questionType.Text"></app-text-form>
      </div>
    </div>
    <div class="row">
      <div *ngIf="isLeftAddButtonEnable()" class="col-4 m-t-20">
        <button
          (click)="addButtonClicked(true)"
          class="m-r-10 float-left btn btn-outline-info waves-effect waves-light btn-white-sm btn-circle"
        >
          <span class="ti-plus"></span>
        </button>
        <div class="w-75 m-t-10 text-muted">Add Answer</div>
      </div>
      <div *ngIf="isRightAddButtonEnable()" class="col-4 offset-2 m-t-20">
        <button
          (click)="addButtonClicked(false)"
          class="m-r-10 float-left btn btn-outline-info waves-effect waves-light btn-white-sm btn-circle"
        >
          <span class="ti-plus"></span>
        </button>
        <div class="w-75 m-t-10 text-muted">Add Answer</div>
      </div>
    </div>
  </div>
  <div class="col-3 drop-down-column">
    <div class="col-12 pr-0 m-t-10" *ngIf="treeviewSelectable">
      <app-multiple-dropdown
        displayText="Select category"
        [items]="treeviewSelectable"
        [allowClear]="false"
        (itemChange)="getSelectedItem($event)"
      ></app-multiple-dropdown>
    </div>
    <div class="col-12 p-r-0 m-t-10">
      <ngx-select
        [items]="questionsTypeItems"
        [formControl]="questionTypesSelectControl"
        placeholder="No form selected"
      >
      </ngx-select>
    </div>
    <div class="col-12 save-question-buttons">
      <div class="row">
        <div class="col-4 text-center p-r-0">
          <button (click)="cancelAddEditForm()" class="btn-cancel waves-light" id="btn-cancel-addnew-question">
            Cancel
          </button>
        </div>
        <div class="col-5">
          <button
            (click)="saveButtonClicked()"
            class="btn-save waves-light"
            [disabled]="isOnSaving"
            id="btn-save-new-question"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
